import apiClient from './apiClient';

const organizationService = {
  getAll: async (page = 1, limit = 20) => {
    const response = await apiClient.get(`/organizations?page=${page}&limit=${limit}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/organizations/${id}`);
    return response.data;
  },

  create: async (payload) => {
    const response = await apiClient.post('/organizations', payload);
    return response.data;
  },

  update: async (id, payload) => {
    const response = await apiClient.put(`/organizations/${id}`, payload);
    return response.data;
  }
};

export default organizationService;
